import { render, staticRenderFns } from "./RegistrationPage.vue?vue&type=template&id=1bbe9494&scoped=true&"
import script from "./RegistrationPage.vue?vue&type=script&lang=ts&"
export * from "./RegistrationPage.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationPage.vue?vue&type=style&index=0&id=1bbe9494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbe9494",
  null
  
)

export default component.exports